export interface LocalStorage<T> {
	readonly setItem: (item: T) => void;
	readonly getItem: (defaultValue?: T) => undefined extends T ? T | undefined : T;
	readonly clear: () => void;
}

export class BrowserLocalStorage<T, U = T> implements LocalStorage<T> {
	readonly setItem: (item: T) => void;
	readonly getItem: (defaultValue?: T) => undefined extends T ? T | undefined : T;
	readonly clear: () => void;
	constructor(
		key: string,
		serialize: (v: T) => U,
		deserialize: (v: U) => T,
		backend: "local" | "session" = "local",
		version = 0
	) {
		const versionedKey = `${key}-${version}`;
		const storage = backend === "local" ? localStorage : sessionStorage;
		this.setItem = (item: T) => {
			try {
				storage.setItem(versionedKey, JSON.stringify(serialize(item)));
			} catch (e) {
				console.warn(e);
			}
		};
		this.getItem = (defaultValue?: T): undefined extends T ? T | undefined : T => {
			try {
				const item = storage.getItem(versionedKey);
				if (item === null) {
					return defaultValue as undefined extends T ? T | undefined : T;
				}
				return deserialize(JSON.parse(item)) as undefined extends T ? T | undefined : T;
			} catch (e) {
				console.warn(e);
				return defaultValue as undefined extends T ? T | undefined : T;
			}
		};
		this.clear = () => storage.clear();
	}
}

export class DummyLocalStorage<T> implements LocalStorage<T> {
	readonly setItem = (): void => {
		// Nothing
	};
	readonly getItem = (defaultValue?: T): undefined extends T ? T | undefined : T =>
		defaultValue as undefined extends T ? T | undefined : T;
	readonly clear = (): void => {
		// Nothing
	};
}
